import React, { useEffect, useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import axios from "../api/apiClient";
import { apiUrl } from "../authconfig";
const steps = [
  {
    title: "Sales Handover Completion Validation",
    checkpoints: [
      { name: "The scope is clear", key: "scpsClear" },
      { name: "The contract rates and terms are signed", key: "cntctRtsTmsSgnClr" },
      { name: "The stakeholders are identified", key: "intExtStkClrIden" },
    ],
  },
  {
    title: "Internal Onboarding",
    checkpoints: [
      { name: "The SOP is created", key: "sopIsCrtd" },
      { name: "The IOP is created", key: "iopIsCrtd" },
      {
        name: "The SOP/IOP are aligned with stakeholders",
        key: "sopIopAlgndWthIntrnlStkhldrs",
      },
    ],
  },
  {
    title: "Customer Onboarding",
    checkpoints: [
      { name: "The Kick-off call is completed", key: "kickOffCallWthCstmrCmpltd" },
      { name: "The Final SOP is signed off by Customer", key: "fnlSopSgndOffByCstmr" },
      {
        name: "The Customer is trained on required systems",
        key: "cstmrIsTraindToUseOurSystm",
      },
    ],
  },
  {
    title: "Go-live and Hypercare",
    checkpoints: [
      { name: "The first booking is received", key: "frstBookngReceived" },
      { name: "The first billing is finalized", key: "blngFrFrstShpmntCrctCmpltd" },
      {
        name: "The Customer Agrees to finalize hypercare and onboarding",
        key: "maerskTmAgrsFnlzeHprcreNdClsOnbrdng",
      },
      {
        name: "An Onboarding Survey is sent to the Customer",
        key: "onbrdngSrvySntTCstmr",
      },
    ],
  },
];

const StartOnboarding = (props) => {
  const { currentModalData } = props;
  const currentUser = JSON.parse(sessionStorage.getItem("user"));
  // const handleCheckboxChange = (stepIndex, checkpointIndex) => {
  //     props.setCompleted((prev) => {
  //       const newCompleted = { ...prev };
  //       newCompleted[stepIndex] = newCompleted[stepIndex] || [];
  //       if (newCompleted[stepIndex].includes(checkpointIndex)) {
  //         newCompleted[stepIndex] = newCompleted[stepIndex].filter((i) => i !== checkpointIndex);
  //       } else {
  //         newCompleted[stepIndex].push(checkpointIndex);
  //       }
  //       return { ...newCompleted };
  //     });
  //   };

  //   const handleCommentChange = (stepIndex, event) => {
  //     props.setComments({ ...props.comments, [stepIndex]: event.target.value });
  //   };

  const handleChange = (e, checkpoint) => {
    //console.log('step',e.target.checked,checkpoint)
    props.setProjectPhaseData({
      ...props.projectPhaseData,
      [checkpoint.key]: e.target.checked,
    });
  };

  const handleClosePhase = async (e, name) => {
    if (props.projectPhaseData?.projectStatus === "Complete") {
      const productData = props.productData;

      if (props.editId !== null && props.editId >= 0) {
        alert("Please save the edited row first in Volume Conversion");
        return;
      }

      const todayDate = new Date();
      const todayOnly = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        todayDate.getDate()
      );
      const actualGoLiveDateOnly = props.projectPhaseData?.actualGoLiveDate
        ? new Date(props.projectPhaseData.actualGoLiveDate)
        : null;

      if (
        actualGoLiveDateOnly &&
        !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
        new Date(
          actualGoLiveDateOnly.getFullYear(),
          actualGoLiveDateOnly.getMonth(),
          actualGoLiveDateOnly.getDate()
        ) > todayOnly
      ) {
        alert("Actual Go-Live Date cannot be a future date.");
        return;
      }

      if (!Array.isArray(productData) || productData.length === 0) {
        alert("Volume Conversion data is mandatory before closing the project.");
        return;
      }

      if (productData.some((item) => !String(item?.bookingReference || "").trim())) {
        alert("Booking Reference is mandatory for all products before closing the project.");
        return;
      }

      const hasActualGoLiveDate = Boolean(props.projectPhaseData?.actualGoLiveDate);
      const hasContactingSalesSelection =
        typeof props.projectPhaseData?.contactingSales === "boolean";
      const isContactingSalesYes = props.projectPhaseData?.contactingSales === true;

      if (!hasActualGoLiveDate) {
        alert(
          "Actual go-live date is required before project closure."
        );
        return;
      }

      if (!hasContactingSalesSelection) {
        alert("Please select whether this project involves contacting Sales for participation.");
        return;
      }

      if (
        isContactingSalesYes &&
        !String(props.projectPhaseData?.reasonForSalesParticipation || "").trim()
      ) {
        alert("Reason for sales participation is required when contacting Sales is Yes.");
        return;
      }

      if (
        isContactingSalesYes &&
        props.projectPhaseData?.reasonForSalesParticipation === "Others" &&
        !String(props.projectPhaseData?.reasonForSalesOther || "").trim()
      ) {
        alert("Please provide details for 'Others' under reason for sales participation.");
        return;
      }

      const agreementStartDate = props.projectPhaseData?.agreementStartDate
        ? new Date(props.projectPhaseData.agreementStartDate)
        : null;
      const isProjectGoLiveDelayedReasonRequired =
        agreementStartDate &&
        actualGoLiveDateOnly &&
        !Number.isNaN(agreementStartDate.getTime()) &&
        !Number.isNaN(actualGoLiveDateOnly.getTime()) &&
        Math.floor(
          (actualGoLiveDateOnly - agreementStartDate) / (1000 * 60 * 60 * 24)
        ) > 15;

      if (
        isProjectGoLiveDelayedReasonRequired &&
        !String(props.projectPhaseData?.projectGoLiveDelayedReason || "").trim()
      ) {
        alert(
          "Project go-live delayed reason is required when Actual Go-Live Date is more than 15 days after Agreement Start Date."
        );
        return;
      }

      if (
        !productData?.every(
          (item) =>
            (item?.averageActualWeeklyVolume / item?.scheduledWeeklyVolume >
              0.8 ||
              item.commentsOnLowVolume) &&
            item?.averageActualWeeklyVolume
        )
      ) {
        alert("Please fill up both values in the Volume Converion Table");
        return;
      }
    }
    if (window.confirm("Are you sure you want to close this phase?") == true) {
      //await props.setProjectPhaseData({ ...props.projectPhaseData, [name]: true });
      axios
        .post(
          `${apiUrl}/api/opportunities/save`,
          {
            ...props.projectPhaseData,
            [name]: true,
            modifiedBy: currentUser?.mail,
            fullOnboarding: true,
            liteOnboarding: false,
            projectPhase: name == "closePhase4" ? "Close Project" : name,
          }
        )
        .then((response) => {
          props.setProjectPhaseData({
            ...props.projectPhaseData,
            [name]: true,
            modifiedBy: currentUser?.mail,
            fullOnboarding: true,
            liteOnboarding: false,
            projectPhase: name == "closePhase4" ? "Close Project" : name,
          });
          props.setCurrentModalData({
            ...props.projectPhaseData,
            [name]: true,
            modifiedBy: currentUser?.mail,
            fullOnboarding: true,
            liteOnboarding: false,
            projectPhase: name == "closePhase4" ? "Close Project" : name,
          });
          //props.handleClose();
          alert("Phase Closed Successfully");
        })
        .catch((error) => {
          alert(error.response.data || "Something went wrong");
          console.log(error);
        });
    }
  };

  const handleCommentChange = (e, key) => {
    props.setProjectPhaseData({
      ...props.projectPhaseData,
      [key]: e.target.value,
    });
  };

  console.log("step", props.projectPhaseData);
  return (
    <Box sx={{ width: "100%", padding: 2, fontSize: "14px" }}>
      {/* <div >Start Onboarding</div> */}
      <Stepper orientation="vertical">
        {steps.map((step, stepIndex) => (
          <Step key={stepIndex}>
            <StepLabel>
              <div style={{ fontSize: "14px" }}>{step.title}</div>
            </StepLabel>
            <Box sx={{ paddingLeft: 4 }}>
              {step.checkpoints.map((checkpoint, checkpointIndex) => (
                <FormControlLabel
                  key={checkpointIndex}
                  sx={{ fontSize: "14px" }}
                  control={
                    <Checkbox
                      checked={
                        props.projectPhaseData
                          ? props.projectPhaseData[checkpoint["key"]]
                          : false
                      }
                      disabled={
                        (props.projectPhaseData &&
                          (props.projectPhaseData.projectStatus == "Complete" ||
                            props.projectPhaseData[
                              `closePhase${stepIndex + 1}`
                            ])) ||
                        currentModalData?.projectStatus == "Cancelled" ||
                        currentModalData?.projectStatus ==
                          "Not in Current Scope" || currentModalData?.assignedUser != currentUser?.mail
                      }
                      onChange={(e) => handleChange(e, checkpoint)}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "14px" }}>
                      {checkpoint.name}
                    </Typography>
                  }
                />
              ))}
              <div
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Comments
              </div>
              <textarea
                style={{ display: "flex", width: "calc(100% - 32px)" }}
                rows={2}
                value={
                  (props.projectPhaseData
                    ? props.projectPhaseData[`phase${stepIndex + 1}Comments`]
                    : "") || ""
                }
                // disabled={

                //   props.projectPhaseData && (props.projectPhaseData[`closePhase${stepIndex + 1}`] )
                //  }
                disabled={
                  currentModalData?.projectStatus == "Cancelled" ||
                  currentModalData?.projectStatus == "Not in Current Scope" ||
                  currentModalData?.projectStatus == "Complete" ||
                  currentModalData?.assignedUser != currentUser?.mail
                }
                onChange={(e) =>
                  handleCommentChange(e, `phase${stepIndex + 1}Comments`)
                }
              />
              <Box sx={{ display: "flex", gap: 1, marginTop: 1 }}>
                <Button
                  className="closePhaseButton"
                  style={{
                    padding: "0 10px",
                    width: "max-content",
                    backgroundColor: "rgb(0, 36, 61)",
                    color: "#fff",
                  }}
                  variant="outlined"
                  color="primary"
                  disabled={
                    (props.projectPhaseData &&
                      ((step.title === "Go-live and Hypercare" &&
                        props.projectPhaseData.projectStatus != "Complete") ||
                        props.projectPhaseData[`closePhase${stepIndex + 1}`] ||
                        props.projectPhaseData[`closePhase${stepIndex}`] ==
                          false)) ||
                    currentModalData?.projectStatus == "Cancelled" ||
                    currentModalData?.projectStatus == "Not in Current Scope" || currentModalData?.assignedUser != currentUser?.mail
                  }
                  onClick={(e) =>
                    handleClosePhase(e, `closePhase${stepIndex + 1}`)
                  }
                >
                  {step.title === "Go-live and Hypercare"
                    ? "Close Project"
                    : "Close Phase"}
                </Button>
              </Box>
            </Box>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StartOnboarding;
